<template>
  <div class="custom-timeline-container">
    <el-timeline>
      <el-timeline-item
        v-for="(item, index) in synopsisList.slice(0,this.lengthNum)"
        :key="index"
        :timestamp="item.time"
        :hide-timestamp="true"
      >
        <template #dot>
          <div :class="index%2 == 1?'custom-dot':'custom-dot custom-dot1'" >
            <!-- <i :class="item.icon"></i> -->
           
            <img src="../../assets/ywbkNew/0/1.png" />
          
          </div>
        </template>
        <div :class="['timeline-content', index % 2 === 0 ? 'left' : 'right']">
          <div class="content-card">
            <h3>{{ item.dateSite }}</h3>
            
            <p>
              <el-tooltip :content="item.synopsis" placement="bottom" effect="light" class="mytoolTip">
                <el-button>{{ item.synopsis.substring(0,26) }} {{ item.synopsis.length>26?'...':'' }}</el-button>
              </el-tooltip>
              <!-- <a :title="item.content" style="color: white;">{{ item.content.substring(0,26) }}...</a> -->
            </p>
            <!-- <p v-else :class="item.time == '2014.5.10'?'redFont':''">
              {{ item.synopsis }}
            </p> -->
           </div>
        </div>
      </el-timeline-item>
    </el-timeline>
    <div style="width: 100%; text-align: center;color:#ffffff;font-size:1rem;cursor: pointer;" @click="lengthNumFn">{{ txtStr }}</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      txtStr:'加载更多...',
      lengthNum:14,
      timelineData1:[],
      synopsisList1:[],
    
    } 
  },
  props: {
    
    synopsisList: {
      type: Array,
      default: [],
    },
   },
 
  mounted(){
   
   },
  methods: {
    lengthNumFn(){
    
      this.$nextTick(()=>{
        if(this.lengthNum == this.synopsisList.length){
          this.lengthNum=14
           this.txtStr='加载更多...'
        }else{
          if((this.lengthNum+15)>=this.synopsisList.length){
            this.lengthNum=this.lengthNum+15
             this.txtStr='加载更多...'
          }else{
            this.lengthNum=this.synopsisList.length
            this.txtStr='加载完毕-收起'
          }
        }
        
      })

     
     
    }
  }
}
</script>

<style scoped>
.custom-timeline-container {
  width: 90%;
  margin: 0 auto;
  /* border:2px solid red; */
  margin: 0 auto;
  padding: 20px;
}

/* 自定义节点样式 */
.custom-dot {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  position: relative;
}
.custom-dot::before{
  content: '';
  position: absolute;
  top: 0.5rem;
  left:1.5vw;
  display: inline-block;
  width: 10vw;
  height: 0.2rem;
  background: linear-gradient(to right, #fcfcfb, rgba(253, 252, 252, 0));
 
}
.custom-dot1::before{
  content: '';
  position: absolute;
  top: 0.5rem;
  left:-10.5vw;
  display: inline-block;
  width: 10vw;
  height: 0.2rem;
  background: linear-gradient(to right, #fcfcfb, rgba(253, 252, 252, 0));
  transform: rotateY(180deg);
 
}
@media screen and (max-width: 768px) {
  .custom-dot::before{
    display: none;
  }
  .custom-dot1::before{
    display: none;
  }
  }

.dot-primary {
  background-color: #409EFF;
}

.dot-success {
  background-color: #67C23A;
}

.dot-warning {
  background-color: #E6A23C;
}

/* 时间线内容样式 */
.timeline-content {
  position: relative;
  width: calc(50% - 50px);
  /* padding-bottom: 30px; */
}

.timeline-content.left {
  left: 0;
  text-align: right;
  padding-right: 10rem;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .timeline-content.left {
    padding-right:0;
    padding-top: 2rem;
  }
}
  

.timeline-content.right {
  left: 50%;
  text-align: left;
  padding-left: 10rem;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .timeline-content.right {
    padding-left: 0;
    padding-top: 2rem;
  }
}

.content-card {
  padding: 15px;
  padding-top:0;
  /* background: #fff; */
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.content-card h3 {
  margin-top: 0;
  color: #ffffff;
  font-size: 1.1rem;
  line-height: 2rem;
}

.content-card p {
  color: #ffffff;
  /* margin-bottom: 5px; */
  * {
    font-size: 1rem;

  }
  
}
.content-card p.redFont{
  color: red;
 }
 

/* 时间线连接线样式 */
::v-deep .el-timeline-item__tail {
  left: 50%;
  transform: translateX(-50%);
}
::v-deep .el-timeline-item__dot{
  left:50%;
  transform: translateX(-50%);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .timeline-content {
    width: 100%;
    left: 0 !important;
    text-align: left !important;
    /* padding: 0 0 0 70px !important; */
  }
  
  .el-timeline-item__tail,
  .el-timeline-item__node {
    left: 12px !important;
   display: none !important;
  }

}
.el-timeline-item{
  padding-bottom: 0 !important;
}
 
.mytoolTip{
  background: none !important;
  border: none !important;
  font-size: 1rem !important;
  color: #ffffff;
}


</style>
 
